<template>
    <base-component>
        <template slot="form">
            <search-task :tasksService="tasksService" :is-operator="isOperator" @onSearch="search" @onError="handleError"/>
        </template>

        <template slot="workArea">
            <b-alert variant="danger" :show="showAlert">
                {{ alert }}
            </b-alert>

            <b-card :no-body="!isOperator" class="flex-fill flex-shirink-0">
                <b-tabs v-if="!isOperator" card>
                    <b-tab :title="$t('menu.kkms')" @click="openKkms"/>
                    <b-tab v-if="!isInspector" :title="$t('menu.blockedKkms')" @click="openBlockedKkms"/>
                    <b-tab v-if="!isOperator" :title="$t('menu.reports')" @click="openReports"/>
                    <b-tab v-if="!isOperator" :title="$t('menu.tickets')" @click="openTickets"/>
                    <b-tab v-if="!isOperator" :title="$t('menu.moneyPlacements')" @click="openMoneyPlacements"/>
                    <b-tab :title="$t('menu.tasks')" active>
                        <pagination :pageSize="pageSize" :offset="offset" :listLenght="tasks.length" :setOffset="setOffset"/>
                        <task-table :tasks="tasks"/>
                    </b-tab>
                </b-tabs>

                <div v-else>
                    <pagination :pageSize="pageSize" :offset="offset" :listLength="tasks.length" :setOffset="setOffset"/>
                    <task-table :tasks="tasks"/>
                </div>
            </b-card>
        </template>
    </base-component>
</template>

<script>
import AppData from '@/utils/appdata'
import TasksService from '@/services/TasksService';

const TaskTable = () => import(/* webpackChunkName: "chunk-views" */ '@/components/task/TaskTableComponent.vue');
const SearchTask = () => import(/* webpackChunkName: "chunk-views" */ '@/components/task/TaskSearchComponent.vue');
const Pagination = () => import(/* webpackChunkName: "chunk-views" */ '@/components/general/Pagination.vue');

export default {
    name: 'Tasks',
    mixins: [AppData],
    components: {
        Pagination,
        TaskTable,
        SearchTask
    },
    data() {
        return {
            tasksService: {},
            tasks: [],
            pageSize: 20,
            offset: 0,
            lastRequest: {}
        }
    },
    created() {
        this.tasksService = new TasksService(
            this.$appConfig.apiUrls.task, 
            (url, data) => this.$request.sendRequestAsync(this, url, data)
        );
    },
    methods: {
        async setOffset(offset) {
            this.offset = offset;

            this.lastRequest['offset'] = offset;

            await this.updateTasksList(this.lastRequest);
        },
        
        async search(filter) {
            this.offset = 0;
            
            this.alert = '';
            this.showAlert = false;
            
            if (!this.isOperator)
                filter.creatorId = this.$store.getters.getUserId;

            this.lastRequest = {
                ...filter,
                pageSize: this.pageSize,
                offset: this.offset
            };

            await this.updateTasksList(this.lastRequest);
        },

        async updateTasksList(request) {
            try {
                this.tasks = await this.tasksService.getTasks(request);
            } catch(errorCode){
                this.handleError(errorCode);
            }
        },

        handleError(errorCode) {
            if (typeof(errorCode) === 'number' || typeof(errorCode) === 'string') {
                // FIXME: The method from AppData
                this.displayAlert(errorCode);
            }
            else {
                console.error(errorCode);
            }
        },
        //FIXME: methods
        openKkms() {
            if (this.isTaxpayer) {
                this.$router.push({ name: 'kkms' })
            } else {
                this.$router.push({ name: 'childKkm' })
            }
        },
        openBlockedKkms() {
            if (this.isTaxpayer) {
                this.$router.push({ name: 'kkmsBlocked' })
            } else if (this.isOperator) {
                this.$router.push({ name: 'blockedKkms' })
            }
        },
        openReports() {
            if (this.isTaxpayer) {
                this.$router.push({ name: 'reports' })
            } else if (this.isInspector) {
                this.$router.push({ name: 'childReports' })
            }
        },
        openMoneyPlacements() {
            if (this.isTaxpayer) {
                this.$router.push({ name: 'moneyPlacements' })
            } else if (this.isInspector) {
                this.$router.push({ name: 'childMoneyPlacements' })
            }
        },
        openTickets() {
            if (this.isTaxpayer) {
                this.$router.push({ name: 'tickets' })
            } else if (this.isInspector) {
                this.$router.push({ name: 'childTickets' })
            }
        }
    }
}
</script>